<template>
    <div class="footer">
        <div class="main_content footer_row">
            <div class="footer_left">
                <img class="footer-logo" src="./images/footer-logo.png" alt="logo">
                <div class="footer_left-phone">400-007-5533</div>
                <div class="footer_left-text">工作时间：周一至周日 9:00 - 21：00</div>
                <img class="footer_left-qrcode" src="./images/qrcode.png" alt="qrcode">
                <div class="footer_left-subtext">技术支持</div>
            </div>
            <div class="footer-right">
                <div class="footer-list">
                    <div class="footer-col">
                        <div class="footer-col-title">快麦产品与解决方案</div>
                        <div class="footer-col-content">
                            <div class="footer-col-content-item" @click="openNew('https://cloudprint.kuaimai.com/#/home')">快麦云打印</div>
                            <div class="footer-col-content-item" @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">番茄打印管家</div>
                            <div class="footer-col-content-item" @click="openNew('https://fanqie365.cn/?sc=guanwang')">番茄标签</div>
                            <div class="footer-col-content-item" @click="openNew('https://solution.kuaimai.com/#/home')">番茄打印解决方案</div>
                            <div class="footer-col-content-item" @click="openNew('https://iot.kuaimai.com/#/home')">快麦IoT</div>
                            <div class="footer-col-content-item" @click="openNew('https://www.tyunkeji.com/#/home')">关于我们</div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="footer-col-title">光云旗下产品</div>
                        <div class="footer-col-list">
                            <div class="footer-col-content">
                                <div class="footer-col-content-item" @click="openNew('https://www.kdzs.com/')">快递助手</div>
                                <div class="footer-col-content-item" @click="openNew('https://fuwu.taobao.com/ser/detail.htm?service_code=appstore-9092&tracelog=raycloud')">超级店长</div>
                                <div class="footer-col-content-item" @click="openNew('https://fuwu.taobao.com/ser/detail.htm?service_code=FW_GOODS-1865889&tracelog=raycloud')">旺店交易</div>
                                <div class="footer-col-content-item" @click="openNew('https://fuwu.taobao.com/ser/detail.htm?service_code=FW_GOODS-1859514&tracelog=raycloud')">旺店商品</div>
                                <div class="footer-col-content-item" @click="openNew('https://fuwu.taobao.com/ser/detail.htm?spm=a1z13.pc_search_result.1234-fwlb.5.3f685acanwl9GU&service_code=FW_GOODS-1001097873&tracelog=guanwang')">跟单宝</div>
                            </div>
                            <div class="footer-col-content">
                                <div class="footer-col-content-item" @click="openNew('https://erp.kuaimai.com/')">快麦ERP</div>
                                <div class="footer-col-content-item" @click="openNew('http://www.deepdraw.cn/#/')">深绘设计</div>
                                <div class="footer-col-content-item" @click="openNew('https://kf.kuaimai.com/')">快麦客服</div>
                                <div class="footer-col-content-item" @click="openNew('')">快麦工单</div>
                                <div class="footer-col-content-item" @click="openNew('https://crm.kuaimai.com/')">快麦CRM</div>
                            </div>
                            <div class="footer-col-content">
                                <div class="footer-col-content-item" @click="openNew('https://www.ycbg.com/')">有成办公</div>
                                <div class="footer-col-content-item" @click="openNew('https://fanqier.cn/?from=raycloud')">番茄表单</div>
                                <div class="footer-col-content-item" @click="openNew('https://www.ycbx.com/')">有成报销</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-beian">
                    杭州淘云科技有限公司 版权所有 浙ICP备09083305号 浙公网安备 33010802003954号
                </div>
            </div>
            <img class="footer-bg" src="./images/footer-bg.png" alt="bg">
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer",
    data() {
        return {};
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
/* 底部样式 */
.footer {
    overflow: hidden;
    box-sizing: border-box;
    padding: 66rem 0 0 0;
    height: 491rem;
    background: #1D1D38;

    .footer_row {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;

        .footer_left {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .footer-logo {
                height: 60rem;
                margin-bottom: 48rem;
            }

            .footer_left-phone {
                margin-bottom: 22rem;
                font-family: AppleSystemUIFont;
                font-size: 36rem;
                color: #FD6520;
                white-space: nowrap;
            }

            .footer_left-text {
                margin-bottom: 33rem;
                font-family: AppleSystemUIFont;
                font-size: 14rem;
                color: #FFFFFF;
                white-space: nowrap;
            }

            .footer_left-qrcode {
                width: 106rem;
                margin-bottom: 7rem;
            }

            .footer_left-subtext {
                font-family: AppleSystemUIFont;
                font-size: 18rem;
                color: #FD6520;
            }
        }

        .footer-right {
            display: flex;
            flex-direction: column;
            align-items: center;
            z-index: 2;

            .footer-list {
                display: flex;
                flex-direction: row;
                gap: 112rem;

                .footer-col {
                    display: flex;
                    flex-direction: column;

                    .footer-col-title {
                        margin-bottom: 13rem;
                        font-family: AppleSystemUIFont;
                        font-size: 18rem;
                        color: #FD6520;
                    }

                    .footer-col-list {
                        display: flex;
                        flex-direction: row;
                        gap: 64rem;
                    }

                    .footer-col-content {
                        display: flex;
                        flex-direction: column;

                        .footer-col-content-item {
                            font-family: AppleSystemUIFont;
                            font-size: 14rem;
                            color: #FFFFFF;
                            line-height: 28rem;
                            cursor: pointer;
                            transition: all .3s;

                            &:hover {
                                color: #FD6520;
                            }
                        }
                    }
                }
            }

            .footer-beian {
                margin-top: 103rem;
                font-family: AppleSystemUIFont;
                font-size: 14rem;
                color: #FFFFFF;
            }
        }

        .footer-bg {
            position: absolute;
            bottom: -82rem;
            right: 0;
            height: 508rem;
        }
    }
}
</style>
